// ------------------------------------------
// FVスライダー
// ------------------------------------------
class FvSlider {
  constructor(el, opt) {
    this.root = document.querySelector('.' + el);
    if (!this.root) return;

    this.slides = Array.from(this.root.querySelectorAll('.js-fv-slide'));
    this.pages = Array.from(this.root.querySelectorAll('.js-fv-page'));
    this.interval = (opt && opt.interval) || 6000;
    this.current = 0;
    this.timer = null;

    if (this.slides.length < 2) return;
    this.event();
  }

  event() {
    this.root.style.setProperty('--fv-interval', this.interval + 'ms');

    this.pages.forEach((page, index) => {
      page.addEventListener('click', () => {
        this.goTo(index);
        this.start();
      });
    });

    document.addEventListener('visibilitychange', () => {
      document.hidden ? this.stop() : this.start();
    });

    const firstImgs = this.slides[0].querySelectorAll('img');
    const zoomed = CSS.supports('-moz-appearance', 'none') ? 'scale(1.08) rotate(0.02deg)' : 'scale(1.08)';
    firstImgs.forEach((img) => {
      img.style.transition = 'none';
      img.style.transform = zoomed;
    });
    void this.slides[0].offsetWidth;
    firstImgs.forEach((img) => {
      img.style.transition = '';
      img.style.transform = '';
    });

    this.goTo(0);
    this.start();
  }

  goTo(index) {
    this.slides[this.current].classList.remove('is-active');
    if (this.pages[this.current]) {
      this.pages[this.current].classList.remove('is-active');
      this.pages[this.current].removeAttribute('aria-current');
    }

    this.current = index;
    this.slides[index].classList.add('is-active');

    const page = this.pages[index];
    if (page) {
      void page.offsetWidth;
      page.classList.add('is-active');
      page.setAttribute('aria-current', 'true');
    }
  }

  start() {
    this.stop();
    this.timer = setInterval(() => {
      this.goTo((this.current + 1) % this.slides.length);
    }, this.interval);
  }

  stop() {
    clearInterval(this.timer);
  }
}
